import { ImgHTMLAttributes } from 'react';
import { useAuthedMediaUrl } from '../../hooks/useAuthedMediaUrl';

interface AuthedImageProps extends Omit<ImgHTMLAttributes<HTMLImageElement>, 'src'> {
    src: string;
}

/**
 * Drop-in <img> replacement for media served behind SL_cProxy's Bearer-auth (e.g.
 * /api/cproxy/v1/downloads/*) - a plain <img src> can't carry an Authorization header. See
 * useAuthedMediaUrl / TASKS.md.
 */
export const AuthedImage = ({ src, ...imgProps }: AuthedImageProps) => {
    const blobUrl = useAuthedMediaUrl(src);
    if (!blobUrl) return null;
    return <img src={blobUrl} {...imgProps} />;
};
